import {
	IconButton as MuiIconButton,
	IconButtonProps as MuiIconButtonProps,
} from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";

export interface IconButtonProps extends MuiIconButtonProps {
	link?: string;
	replace?: boolean;
	src: string | React.ReactNode;
	alt: string;
}

export default function IconButton({
	onClick,
	link,
	replace,
	src,
	alt,
	className,
	...args
}: IconButtonProps) {
	const history = useHistory();

	const handleClickButton = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		if (onClick) {
			onClick(e);
		}

		if (link) {
			if (replace) {
				history.replace(link);
			} else {
				history.push(link);
			}
		}
	};

	return (
		<MuiIconButton onClick={handleClickButton} className={className} {...args}>
			{typeof src === "string" ? <img src={src} alt={alt} /> : src}
		</MuiIconButton>
	);
}
